<!--
* UIID: UI-DBI-110 (2nd Tab)
* UI Name:  DB Mapping
* Modify Date: 2023/02/13
-->
<template>
  <div>
    <v-row no-gutters class="scanner-section">
      <v-col cols="12" lg="6" md="6" class="pl-0 pb-0 pt-0 pr-12px">
        <v-row no-gutters>
          <v-col cols="12" class="scanner-grid-pd zoom-mapper-file pt-0 pr-0 pb-0 h-full">
            <v-row v-if="type !== 'D2F' && type !== 'D2D'" class="v-grid-title row-pd">
              <v-col class="date-query-section pa-0 mt-0" cols="12">
                <div class="pl-0 pt-0 pb-0">
                  <span class="scanner-label">DB Mapper</span>
                </div>
              </v-col>
              <v-col class="date-query-section pa-0 mt-0" cols="12" lg="5" md="5">
                <div class="mapper-file-name" v-if="this.mapperFileName != ''">
                  {{ this.mapperFileName }}
                </div>
              </v-col>
              <v-col class="date-query-section pa-0 mt-0 text-right" cols="12" lg="7" md="7">
                <div class="btn-form-control mb-0">
                  <v-menu open-on-hover offset-y>
                    <template v-slot:activator="{ on, attrs, value }">
                      <v-btn class="btn-active btn-browser btn-inline" v-bind="attrs" v-on="on">
                        Load
                        <v-icon :class="value ? 'fa-rotate-180' : ''">
                          mdi mdi-chevron-down
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list class="map-builder-custom-list">
                      <v-list-item
                        v-for="(item, index) in loadTypes"
                        :key="index"
                        @click="changeLoadType(item)"
                      >
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <input
                    @change="inputMapperFileLocal"
                    id="mapper_data"
                    type="file"
                    ref="mapper_data"
                    style="display: none"
                    accept=".xml"
                  />
                  <v-btn @click="openXmlMapperListDialog" class="btn-active btn-browser btn-inline">
                    <v-icon x-small class="mr-1 show-load-icon">fa fa-list</v-icon>
                    <span class="show-load-txt">{{ $t('btn.mapBuilder.mapperList') }}</span>
                  </v-btn>
                  <v-btn
                    v-if="mapperFileID"
                    class="btn-active btn-browser btn-inline"
                    @click="resetDataMapp"
                  >
                    <span class="show-load-txt">New</span>
                  </v-btn>
                  <v-btn x-small text icon class="mr-1 ml-1" style="mb-[2px]" @click="clearTab()">
                    <icon-svg iconName="Eraser" />
                  </v-btn>
                  <v-btn class="btn-expand" x-small text icon @click="expandView('mapper')">
                    <icon-svg iconName="expand2" />
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <v-row
              no-gutters
              class="text-view-scanner text-view-mapper"
              v-if="type !== 'D2F' && type !== 'D2D'"
            >
              <v-col cols="12" md="12" class="CodeMirror">
                <MapperViewer
                  v-model="mapperFileContent"
                  :options="this.cmOption"
                  @changes="onChangeTextView('mapper')"
                  ref="mapperFile"
                ></MapperViewer>
              </v-col>
            </v-row>
            <v-row
              class="btn-grid no-gutters btn-form-control"
              v-if="type !== 'D2F' && type !== 'D2D'"
            >
              <v-col cols="12" lg="6" md="6" class="pa-0 pr-3 text-left">
                <v-btn
                  :disabled="isEmptyMapper"
                  @click="saveMapperFile"
                  class="btn-active btn-search"
                  >{{ $t('btn.common.save') }}</v-btn
                >
                <v-btn
                  :disabled="isEmptyMapper"
                  @click="openLoadFilePop({ mode: 'Save', filetype: 'mapper' })"
                  class="btn-active btn-search"
                  >{{ $t('btn.mapBuilder.saveAs') }}</v-btn
                >
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" lg="6" md="6" class="pa-0 text-right">
                <v-btn :disabled="isEmptyMapper" @click="validateXML" class="btn-active btn-search"
                  >Validate</v-btn
                >
                <v-btn v-if="!checkIn" @click="saveMapperCheckIn" class="btn-active btn-search"
                  >Create</v-btn
                >
                <v-btn v-else @click="saveMapperCheckIn" class="btn-active btn-search">{{
                  $t('btn.mapBuilder.checkIn')
                }}</v-btn>
              </v-col>
              <v-col cols="12" lg="12" md="12" class="d-flex justify-end pt-1">
                <div
                  v-if="invalidMapper"
                  style="width: fit-content;"
                  class="text-left align-self-center pr-0"
                >
                  <p v-if="!mapperFileID" class="mb-0 text-validate pl-3">
                    <icon-svg style="display: inline;" iconName="validate" />DB Mapper must be saved
                    first.
                  </p>
                  <p v-if="!isValidMapper" class="mb-0 text-validate pl-3">
                    <icon-svg style="display: inline;" iconName="validate" />Validation is required.
                  </p>
                  <p
                    v-if="type !== 'J2D' && this.sqlGroupList.length === 0"
                    class="pl-3 mb-0 mt-1 text-validate"
                  >
                    <icon-svg style="display: inline;" iconName="validate" />SQL load is required.
                  </p>
                </div>
              </v-col>
            </v-row>
            <v-row class="row-pd mt-2" v-if="type !== 'J2D'">
              <v-col class="date-query-section pa-0 mt-0" cols="12" lg="3" md="3">
                <div class="pl-0 pt-0 pb-0">
                  <span class="scanner-label">SQL</span>
                </div>
              </v-col>
              <v-col class="date-query-section pa-0 mt-0 text-right" cols="12" lg="9" md="9">
                <div class="btn-form-control mb-0">
                  <v-btn class="btn-active btn-browser btn-inline" @click="openDBAdapterSQL">
                    <span class="show-load-txt">Load</span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters class="build-result-view" v-if="type !== 'J2D'">
              <v-col
                cols="12"
                md="12"
                :class="['mt-1 pa-0 bg-db-left', type == 'D2D' || type == 'D2F' ? 'h-full' : '']"
                :style="
                  type == 'D2D' || type == 'D2F'
                    ? 'overflow: auto;'
                    : 'height: 119px; overflow: auto;'
                "
              >
                <v-data-table
                  :headers="headers"
                  :items="sqlGroupList"
                  :hide-default-footer="true"
                  :fixed-header="true"
                  class="list-table code-table srm-list-table custom-border-table"
                  no-data-text="No matching records found"
                >
                  <template v-slot:item.testing="{ items }">
                    <icon-svg @click.stop style="margin: 0 auto" size="18" iconName="testing" />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row class="row-pd" v-if="type === 'J2D'">
              <v-col
                class="date-query-section pa-0 mt-0"
                cols="12"
                :lg="this.jsonFileName != '' ? 12 : 3"
                :md="this.jsonFileName != '' ? 12 : 3"
              >
                <div class="pl-0 pt-0 pb-0">
                  <span class="scanner-label">Input JSON</span>
                </div>
              </v-col>
              <v-col
                v-if="this.jsonFileName != ''"
                class="date-query-section pa-0 mt-0"
                cols="12"
                lg="3"
                md="3"
              >
                <div class="file-name" style="display: contents;">
                  {{ this.jsonFileName }}
                </div>
              </v-col>
              <v-col class="date-query-section pa-0 mt-0 text-right" cols="12" lg="9" md="9">
                <div class="btn-form-control mb-0">
                  <v-menu open-on-hover offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="btn-active btn-browser btn-inline mr-0"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Load
                      </v-btn>
                    </template>
                    <v-list class="map-builder-custom-list">
                      <v-list-item
                        v-for="(item, index) in loadTypes"
                        :key="index"
                        @click="changeLoadJsonType(item)"
                      >
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <input
                    @change="inputJsonFileLocal"
                    id="json_data"
                    type="file"
                    ref="json_data"
                    style="display: none"
                    accept=".json"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12" class="mt-1 pa-0">
                <div
                  class="CodeMirror cus-json-view pa-0"
                  :style="
                    this.jsonFileName != '' ? 'height: 93px !important' : 'height: 121px !important'
                  "
                >
                  <JsonViewer
                    v-model="jsonFileContent"
                    :options="this.cmOption"
                    @changes="onChangeTextView('json')"
                    ref="json"
                  ></JsonViewer>
                </div>

                <div class="btn-form-control data-query-section pl-0 py-0 mt-2 mr-0">
                  <v-btn
                    @click="saveJsonFile"
                    :disabled="isValidJson"
                    class="btn-active btn-execute"
                  >
                    {{ $t('btn.dbMapperTest.xmlMapper.save') }}
                  </v-btn>
                  <v-btn
                    @click="openLoadFilePop({ mode: 'Save', filetype: 'json' })"
                    :disabled="isValidJson"
                    class="btn-active btn-search mt-0 mb-0"
                  >
                    {{ $t('btn.dbMapperTest.xmlMapper.saveA') }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="6" md="6">
        <v-row no-gutters>
          <v-col cols="12" xl="12" lg="12" md="12" class="pa-0">
            <v-row no-gutters>
              <v-col cols="12" class="scanner-grid-pd zoom-output-file pt-0 h-full">
                <v-row class="v-grid-title row-pd mb-2">
                  <span class="scanner-label">Test Result & Output (JSON)</span>
                </v-row>
                <v-row
                  no-gutters
                  class="text-view-biz"
                  :style="
                    type !== 'D2F' && type !== 'D2D' ? 'margin-top: 35px' : 'margin-top: 12px'
                  "
                >
                  <div class="CodeMirror">
                    <resultBuildViewer
                      :value="resultFieldTest"
                      :options="this.buildCmOption"
                      ref="resultBuild"
                    ></resultBuildViewer>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialogWindow
      ref="validateDialog"
      size="max"
      title="Warning"
      color="validation"
      :detail="validateMessage"
    ></dialogWindow>
    <dialogWindow
      ref="compileWarningDialog"
      size="max"
      title="Warning"
      color="validation"
      :detail="$t('msg.mapBuilder.compileWarning')"
    ></dialogWindow>
  </div>
</template>
<script>
import MapperViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import resultBuildViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import JsonViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import { mapState } from 'vuex';
import $ from 'jquery';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import cfg from '@/vue-caas/config/config.js';
import { nullOrEmpty } from '@/vue-dlb/common/common';

export default {
  components: {
    MapperViewer,
    resultBuildViewer,
    JsonViewer,
    dialogWindow,
    IconSvg,
  },
  props: {
    type: String,
    resultTestField: String,
    outputFileContent: String,
    checkIn: Boolean,
    dbMapperId: String,
  },
  computed: {
    ...mapState('mapbuilder', {
      buildResult: 'buildResult',
      libList: 'libList',
      movedata: 'movedata',
    }),
    ...mapState('common', {
      fileContent: 'fileContent',
      fileViewWindowParam: 'fileViewWindowParam',
    }),
    resultFieldTest() {
      return this.outputFileContent
        ? this.outputFileContent + '\n' + this.resultTestField
        : this.resultTestField;
    },
    cmOption() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          readOnly: false,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        readOnly: false,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      };
    },
    buildCmOption() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          styleActiveLine: true,
          lineNumbers: false,
          line: false,
          readOnly: true,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        styleActiveLine: true,
        lineNumbers: false,
        line: false,
        readOnly: true,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      };
    },
    isEmptyMapper() {
      if (nullOrEmpty(this.mapperFileContent)) {
        return false;
      }
      return true;
    },
    isEmptyJson() {
      if (nullOrEmpty(this.jsonFileContent)) {
        return false;
      }
      return true;
    },
    isValidCompileMapper() {
      if (this.mapperFileName != '') {
        return false;
      }
      return true;
    },
    isValidJson() {
      if (this.jsonFileContent.toString().trim() != '') {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      invalidMapper: '',
      isValidMapper: false,
      lastFoldIdMapper: '',
      selectCodeId: '',
      isDisableChkMap: true,
      tab: null,
      lastFoldIdBiz: '',
      jsonFileContent: '',
      jsonFileName: '',
      jsonFileID: '',
      jsonFileNameSave: '',
      jsonFileSize: 0,
      jsonFileExtension: '',
      jsonFile: '',
      jsonFolderId: '',
      jsonFileStatus: '',
      mapperFileContent: '',
      mapperFileName: '',
      mapperFile: '',
      mapperFileID: '',
      mapperFileSize: 0,
      mapperFolderId: '',
      mapperFileExtension: '',
      mapperFileNameSave: '',
      mapperFileStatus: '',
      resultField: '',
      buildResultMSG: '',
      isSaved: false,
      validateMessage: '',
      saveItemsParams: {
        header: [
          'SYSSTATUS',
          'USER_ID',
          'FOLD_ID',
          'FILE_ID',
          'USR_FILE_NAME',
          'USR_FILE_SIZE',
          'USR_FILE_TYPE',
          'USR_FILE_KIND',
        ],
        data: [],
      },
      librarySearchItem: {
        header: ['CUST_ID'],
        data: [
          {
            CUST_ID: '',
          },
        ],
      },
      libraryItem: [],
      libraryVersion: '',
      oracleVersion: '',
      isDlb: false,
      loadTypes: [
        { text: 'Load From Local', value: 'local' },
        { text: 'Load From Server', value: 'server' },
      ],
      headers: [],
      dbType: '',
      sqlGroupList: [],
      resultTest: {},
      saveDBMapping: {},
      sqlGroupId: '',
      dbMapperItem: {},
      d2dhead: [
        {
          text: this.$t('tbl.datasource.queryPool.no'),
          value: 'rowid',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('tbl.datasource.queryPool.queryName'),
          value: 'sql_cnt_nm',
          width: '120px',
          align: 'center',
        },
        {
          text: this.$t('tbl.datasource.queryPool.type'),
          value: 'sql_cnt_tp',
          align: 'center',
        },
        {
          text: this.$t('tbl.datasource.queryPool.queryText'),
          value: 'sql_cnt_txt',
          align: 'center',
        },
        {
          text: this.$t('tbl.datasource.queryPool.dbType'),
          value: 'sql_src_trg_flag',
          align: 'center',
        },
        {
          text: this.$t('tbl.datasource.queryPool.dbInstance'),
          value: 'sql_db_instance',
          align: 'center',
        },
        {
          text: this.$t('tbl.datasource.queryPool.func'),
          value: 'sql_func_type',
          align: 'center',
        },
        {
          text: this.$t('tbl.datasource.queryPool.seq'),
          value: 'sql_content_seq',
          align: 'center',
        },
        { text: 'Testing', value: 'testing', sortable: false },
      ],
      normalhead: [
        { text: 'ID', value: 'sql_cnt_id' },
        { text: 'Query Name', value: 'sql_cnt_nm' },
        { text: 'Type', value: 'sql_cnt_tp' },
        { text: 'Query Text', value: 'sql_cnt_txt' },
        { text: 'Testing', value: 'testing', sortable: false },
      ],
    };
  },

  async created() {
    this.$emit('isCheckIn', false);
    this.getLibraryVersion();
    this.isDlb = cfg.isDlb;
    this.headers = this.normalhead;
    if (this.$props.dbMapperId) {
      this.$store
        .dispatch('getDBMapperAdapterDetail', { mapper_id: this.$props.dbMapperId })
        .then(() => {
          this.dbMapperItem = this.$store.getters.dbMapperAdapterItem;
          if (Object.keys(this.dbMapperItem).length !== 0) {
            this.mapperFileContent = this.dbMapperItem.file_content;
            this.mapperFileName = this.dbMapperItem.mapper_name;
            this.sqlGroupId = this.dbMapperItem.sql_grp_id;
            this.mapperFileID = this.dbMapperItem.mapper_file_id;
            if (nullOrEmpty(this.mapperFileName)) {
              this.isValidMapper = true;
              // this.$emit('saveMapperCheckIn');
            }
            if (this.mapperFileID) this.$emit('isCheckIn', true);
          }
        })
        .then(() => {
          if (nullOrEmpty(this.dbMapperItem.sql_grp_id)) {
            this.$store
              .dispatch('getSQLGroupDetail', { sqlGroupId: this.dbMapperItem.sql_grp_id })
              .then(() => {
                this.sqlGroupList = this.$store.getters.sqlGroupDetailList;
                const fun = this.$store.getters.sqlGroupDetailList.filter((e) => e.sql_func_nm);
                if (fun.length > 0) {
                  this.headers = this.d2dhead;
                } else {
                  this.headers = this.normalhead;
                }
              });
          }
        });
    }

    if (this.movedata.length > 0 && this.movedata[0].flag === 'Y') {
      this.mapperFileContent = this.movedata[1];
      this.mapperFileName = this.movedata[2].MAPPER_NAME;
      this.mapperFileNameSave = this.movedata[2].MAPPER_NAME;
    }
    this.clearMovedData();
    EventBus.$on('select-sql-group', this.selectSQLGroup);
    EventBus.$on('updateDBMapperContent', this.updateDBMapperContent);
  },

  watch: {
    type() {
      this.dbType = this.type;
      this.clearTab();
      this.$emit('reset-result-test-field');
    },
    mapperFileID() {
      if (!nullOrEmpty(this.mapperFileID)) {
        this.isValidMapper = false;
      }
    },
  },

  methods: {
    updateDBMapperContent(item) {
      console.log('item', item);
      this.$emit('isCheckIn', true);
      this.saveDBMapping = item;
      this.mapperFileContent = item.file_content ? item.file_content : '';
      this.mapperFileName = item.mapper_name;
      this.sqlGroupId = item.sql_grp_id;
      this.mapperFileID = item.mapper_file_id;
      Store.commit('SET_STORE_DB_MAPPER_ID', item.mapper_id);
      this.isDisableChkMap = false;
      if (item.sql_grp_id) {
        this.$store
          .dispatch('getSQLGroupDetail', { sqlGroupId: item.sql_grp_id })
          .then(() => {
            this.sqlGroupList = this.$store.getters.sqlGroupDetailList;
          })
          .catch((ex) => {});
      }
      this.$emit('change-type-db-mapper', item.mapper_type);
      this.$emit('close-mapper-list-dialog');
    },
    validateXML() {
      Store.dispatch('validateXML', { content: this.mapperFileContent }).then(() => {
        this.resultTest = this.$store.getters.resultXMLValidate;
        if (this.resultTest.result && this.resultTest.result.status === 'VALID')
          this.isValidMapper = true;
        this.resultField =
          this.resultTest.result.status +
          '\n' +
          this.resultTest.result.message +
          '\n' +
          this.resultTest.result.detail;
        this.$emit('change-result-test', this.resultField);
      });
    },
    selectSQLGroup(item, group_id) {
      const fun = item.filter((e) => e.sql_func_nm);
      if (fun.length > 0) {
        this.headers = this.d2dhead;
      } else {
        this.headers = this.normalhead;
      }
      this.sqlGroupList = item;
      this.sqlGroupId = group_id;
      this.$emit('close-dialog-sql-group');
    },
    clearTab() {
      this.clearView('mapper');
      this.clearView('json');
    },
    clearMovedData() {
      var flag = 'N';
      Store.dispatch('mapbuilder/clearMovedData', flag);
    },
    onVersionChange(libver) {
      for (let i = 0; i < this.libList.length; i++) {
        if (libver === this.libList[i].SITE_CODE) {
          this.oracleVersion = this.libList[i].ORA_VER;
          break;
        }
      }
    },
    getLibraryVersion() {
      this.librarySearchItem.data[0].CUST_ID = $cookies.get('comp-id');
      Store.dispatch('mapbuilder/queryLibraryList', this.librarySearchItem).then(() => {
        for (let i = 0; i < this.libList.length; i++) {
          if (this.isDlb) {
            let item = this.libList[i];
            this.libraryItem.push({
              text: item.SITE_NAME,
              value: item.SITE_CODE,
            });
          } else {
            if (this.libList[i].SITE_CODE === 'for_platform') {
              let item = this.libList[i];
              this.libraryItem.push({
                text: item.SITE_NAME,
                value: item.SITE_CODE,
              });
            }
          }
        }
        this.libraryVersion = this.libraryItem[0].value;
        this.onVersionChange(this.libraryVersion);
      });
    },
    saveMapperFile() {
      if (this.mapperFileName === '') {
        this.openLoadFilePop({ mode: 'Save', filetype: 'mapper' });
        return;
      } else {
        if (this.mapperFileContent.toString().trim() == '') {
          this.validateMessage = this.$t('msg.common.require', ['Mapper Content']);
          this.$refs.validateDialog.dialog = true;
          return;
        } else {
          let savefile = {};
          savefile.SYSSTATUS = 'U';
          savefile.USER_ID = $cookies.get('user-id');
          savefile.FOLD_ID = this.mapperFolderId;
          savefile.FILE_ID = this.mapperFileID;
          savefile.FILE_NAME = this.mapperFileName;
          savefile.USR_FILE_SIZE = new Blob([this.mapperFileContent]).size;
          savefile.FILE_TYPE = this.mapperFileExtension;
          savefile.file = this.mapperFileContent;
          savefile.FILE_CONTENT = this.mapperFileContent;
          savefile.USR_FILE_KIND = 'MAP';
          savefile.FILE_STATUS = this.mapperFileStatus;
          this.saveItemsParams.data[0] = savefile;
          Store.dispatch('updateXmlMapBuiderFile', this.saveItemsParams.data[0]).then(() => {
            this.isSaved = true;
          });
        }
      }
    },
    loadMapperLocal() {
      this.$refs.mapper_data.click();
    },
    inputMapperFileLocal(e) {
      this.mapperFileName = '';
      this.mapperFileID = '';
      this.mapperFileNameSave = e.target.files[0].name;
      this.mapperFileExtension = e.target.files[0].name.split('.').pop();
      this.mapperFileSize = e.target.files[0].size;
      this.mapperFile = e.target.files[0];
      this.buildResultMSG = '';
      this.mapperFileID = '';
      this.resultField = '';
      this.isSaved = false;
      var reader = new FileReader();
      reader.onload = (e) => {
        this.mapperFileContent = reader.result;
      };
      reader.readAsText(e.target.files[0]);
    },
    openLoadFilePop(data) {
      let { mode, filetype } = data;
      if (mode == 'Load') {
        let callback = (row) => {
          Store.dispatch('common/viewFileData', row.FILE_ID).then(() => {
            if (filetype == 'json') {
              this.$refs.json_data.value = null;
              let row = this.$store.getters.viewFileData[0];
              this.jsonFileContent = row.FILE_CONTENT;
              this.jsonFileID = row.FILE_ID;
              this.jsonFileName = row.FILE_NAME;
              this.jsonFileNameSave = row.FILE_NAME;
              this.jsonFileSize = row.USR_FILE_SIZE;
              this.jsonFileExtension = row.FILE_TYPE;
              this.jsonFolderId = row.FOLD_ID;
              this.lastFoldIdBiz = row.FOLD_ID;
              this.jsonFileStatus = row.FILE_STATUS;
            } else if (filetype == 'mapper') {
              this.$refs.mapper_data.value = null;
              let row = this.$store.getters.viewFileData[0];
              this.mapperFileContent = row.FILE_CONTENT;
              this.mapperFileID = row.FILE_ID;
              this.mapperFileName = row.FILE_NAME;
              this.mapperFileNameSave = row.FILE_NAME;
              this.mapperFileSize = row.USR_FILE_SIZE;
              this.mapperFileExtension = row.FILE_TYPE;
              this.mapperFolderId = row.FOLD_ID;
              this.resultField = '';
              this.buildResultMSG = '';
              this.isSaved = true;
              this.isDisableChkMap = false;
              this.lastFoldIdMapper = row.FOLD_ID;
              this.mapperFileStatus = row.FILE_STATUS;
            }
          });
        };
        this.$emit('openLoadFile', {
          mode: 'Load',
          filetype: filetype,
          lastFoldIdBiz: this.lastFoldIdBiz,
          lastFoldIdMapper: this.lastFoldIdMapper,
          callback,
        });
      }
      if (mode == 'Save') {
        let callback = (row) => {
          if (filetype == 'json') {
            this.jsonFileName = row.FILE_NAME;
            this.jsonFileNameSave = row.FILE_NAME;
            this.$refs.json_data.value = null;
            this.jsonFileContent = row.file;
            this.jsonFileID = row.FILE_ID;
            this.jsonFileSize = row.FILE_SIZE;
            this.jsonFileExtension = row.FILE_TYPE;
            this.jsonFolderId = row.FOLD_ID;
            this.lastFoldIdBiz = row.FOLD_ID;
          } else if (filetype == 'mapper') {
            this.$refs.mapper_data.value = null;
            this.mapperFileContent = row.file;
            this.mapperFileID = row.FILE_ID;
            this.mapperFileName = row.FILE_NAME;
            this.mapperFileNameSave = row.FILE_NAME;
            this.mapperFileSize = row.USR_FILE_SIZE;
            this.mapperFileExtension = row.FILE_TYPE;
            this.mapperFolderId = row.FOLD_ID;
            this.lastFoldIdMapper = row.FOLD_ID;
            this.isSaved = true;
          }
        };
        let content = [];
        if (filetype == 'json') {
          content.push(this.jsonFileContent);
          if (this.jsonFileExtension == '') {
            this.jsonFileExtension = 'json';
          }
          content.push(this.jsonFileExtension);
          content.push(this.jsonFileNameSave);
          content.push('BIZ');
        } else if (filetype == 'mapper') {
          content.push(this.mapperFileContent);
          if (this.mapperFileExtension == '') {
            this.mapperFileExtension = 'xml';
          }
          content.push(this.mapperFileExtension);
          content.push(this.mapperFileNameSave);
          content.push('MAP');
        }
        this.$emit('openLoadFile', {
          mode: 'Save',
          filetype: filetype,
          content,
          lastFoldIdBiz: this.lastFoldIdBiz,
          lastFoldIdMapper: this.lastFoldIdMapper,
          callback,
        });
      }
    },
    openXmlMapperListDialog(itemRow) {
      this.$emit('openXmlMapperListDialog');
    },
    clearView(type) {
      if (type === 'mapper') {
        this.mapperFileName = '';
        this.mapperFileContent = '';
        this.mapperFileID = '';
        this.isDisableChkMap = true;
        this.resultField = '';
        this.buildResultMSG = '';
        this.mapperFileNameSave = '';
        this.mapperFileSize = '';
        this.mapperFileExtension = '';
        this.mapperFolderId = '';
        this.isValidMapper = false;
        this.sqlGroupList = [];
        this.saveItemsParams.data[0] = {};
      } else if (type === 'json') {
        this.jsonFileName = '';
        this.jsonFileContent = '';
        this.jsonFileID = '';
        this.jsonFolderId = '';
        this.jsonFileNameSave = '';
        this.jsonFileStatus = '';
      }
    },
    expandView(type) {
      if (type === 'mapper') {
        this.$refs.mapperFile.cminstance.setOption('fullScreen', true);
        $('.m-biz-add-row').remove();
        $('.output-add-row').remove();
        var div = document.createElement('div');
        div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
          title: 'Mapper File',
          iconClass: 'icon-collapse-mapper',
        });
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'mapper-add-row' });
        $('.zoom-mapper-file .CodeMirror-fullscreen').prepend(div);
        $('.icon-collapse-mapper').on('click', { type: 'mapper' }, this.closeExpand);
      }
    },
    closeExpand(e) {
      if (e.data.type == 'mapper') {
        $('.mapper-add-row').remove();
        $('.build-add-row').remove();
        this.$refs.mapperFile.cminstance.setOption('fullScreen', false);
        this.$refs.resultBuild.cminstance.setOption('fullScreen', false);
      }
    },
    saveMapperCheckIn() {
      this.invalidMapper = false;
      if (
        !this.isValidMapper ||
        (this.sqlGroupList.length === 0 && this.type === 'D2J') ||
        !this.mapperFileID
      ) {
        this.invalidMapper = true;
        return;
      }
      this.$emit('saveMapperCheckIn');
    },
    openCodeTableDialog() {
      this.$emit('openCodeTableDialog');
    },
    onChangeTextView(type) {
      if (type === 'json') {
        this.$refs.json_data.value = null;
      } else if (type === 'mapper') {
        this.$refs.mapper_data.value = null;
        this.isValidMapper = false;
      }
    },
    openDBAdapterSQL() {
      this.$emit('openDBAdapterSQL');
    },
    loadJsonLocal() {
      this.$refs.json_data.click();
    },
    inputJsonFileLocal(e) {
      this.jsonFileName = '';
      this.jsonFileID = '';
      this.jsonFileNameSave = e.target.files[0].name;
      this.jsonFileExtension = e.target.files[0].name.split('.').pop();
      this.jsonFile = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.jsonFileContent = reader.result;
      };
      reader.readAsText(e.target.files[0]);
    },
    changeLoadJsonType(type) {
      if (type.value === 'local') {
        this.loadJsonLocal();
      } else {
        this.openLoadFilePop({ mode: 'Load', filetype: 'json' });
      }
    },
    saveJsonFile(mode) {
      if (this.jsonFileName === '') {
        this.openLoadFilePop({ mode: 'Save', filetype: 'json' });
        return;
      } else {
        if (this.jsonFileContent.toString().trim() == '') {
          this.validateMessage = this.$t('msg.common.require', ['Biz Data Content']);
          this.$refs.validateDialog.dialog = true;
          return;
        } else {
          let savefile = {};
          savefile.SYSSTATUS = 'U';
          savefile.USER_ID = $cookies.get('user-id');
          savefile.FOLD_ID = this.jsonFolderId;
          savefile.FILE_ID = this.jsonFileID;
          savefile.FILE_NAME = this.jsonFileName;
          savefile.USR_FILE_SIZE = new Blob([this.jsonFileContent]).size;
          savefile.FILE_TYPE = this.jsonFileExtension;
          savefile.file = this.jsonFileContent;
          savefile.FILE_CONTENT = this.jsonFileContent;
          savefile.USR_FILE_KIND = 'BIZ';
          savefile.FILE_STATUS = this.jsonFileStatus;
          this.saveItemsParams.data[0] = savefile;
          Store.dispatch('updateXmlMapBuiderFile', this.saveItemsParams.data[0]).then(() => {
            this.isSaved = true;
          });
        }
      }
    },
    changeLoadType(type) {
      if (type.value === 'local') {
        this.loadMapperLocal();
      } else {
        this.openLoadFilePop({ mode: 'Load', filetype: 'mapper' });
      }
    },
    resetDataMapp() {
      this.invalidMapper = true;
      Store.commit('SET_STORE_DB_MAPPER_ID', '');
      this.$emit('isCheckIn', false);
      const fileContent = this.mapperFileContent;
      this.clearTab();
      this.mapperFileContent = fileContent;
      this.$emit('reset-result-test-field');
    },
  },
};
</script>

<style></style>
